/**
 * ### SolutionFaqDisclosureIcon
 *
 * Draws the open/closed affordance for a FAQ row. The vertical stroke is hidden
 * once the parent row is marked expanded, turning the plus into a minus through
 * CSS alone so the icon stays correct in the server-rendered markup.
 *
 * @param props Class string carrying the tone color and responsive size
 * @returns The rendered indicator element
 */
export default function SolutionFaqDisclosureIcon({
  className,
}: {
  className: string;
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path d="M5 12h14" />
      <path d="M12 5v14" className="group-data-[expanded]:hidden" />
    </svg>
  );
}
